import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import getPagedRequest from "@/helpers/pagerDuty";
import { meetingAPI } from "@/api";
import OutcomeSortType from "@/constants/OutcomeSortType";
import OutcomeType from "@/constants/OutcomeType";
import { store } from "@/store/store";
import debounce from "lodash/debounce";

const DEFAULT_PAGE_SIZE = 25;
const DEBOUNCE_INTERVAL = 5000;
let commitmentsDispatcher;

export const initWebSocketListeners = () => {
	const commitmentsUpdateDispatcher = ( { outcomeId, } ) => {
		const { id: personId, } = store.getters[ "userProfile/userProfile" ];
		store.dispatch( "commitments/refreshCommitments", { outcomeId, personId, } );
	};

	const updateCommitments = ( {
		body: {
			outcomeId,
			personId: updaterPersonId,
		},
	} ) => {
		const { id: personId, } = store.getters[ "userProfile/userProfile" ];
		if ( updaterPersonId !== personId ) {
			if ( !commitmentsDispatcher ) {
				commitmentsDispatcher = debounce( commitmentsUpdateDispatcher, DEBOUNCE_INTERVAL );
			}
			commitmentsDispatcher( { outcomeId, } );
		}
	};

	const removeCommitment = ( {
		body: {
			outcomeId,
			personId: updaterPersonId,
		},
	} ) => {
		const { id: personId, } = store.getters[ "userProfile/userProfile" ];
		if ( updaterPersonId !== personId ) {
			store.dispatch( "commitments/removeCommitment", { outcomeId, personId, } );
			store.dispatch( "myCommitments/removeMyCommitment", { outcomeId, } );
		}
	};

	addSocketMessageListener( SocketMessageType.OUTCOME_CREATED, updateCommitments );
	addSocketMessageListener( SocketMessageType.OUTCOME_UPDATED, updateCommitments );
	addSocketMessageListener( SocketMessageType.OUTCOME_DELETED, removeCommitment );
};

export const loadMyOutstandingOutcomes = getPagedRequest( {
	autoStart: false,
	limit: DEFAULT_PAGE_SIZE,
	request( { offset, limit, outcomeStatus, personId, } ) {
		return meetingAPI.fetchOutcomes( {
			personId,
			outcomeStatus,
			outcomeType: OutcomeType.COMMITMENT,
			sortType: OutcomeSortType.OUTCOME_IMPORTANCE,
			offset,
			limit,
		} );
	},
	onResponse( commitments ) {
		store.dispatch( "myCommitments/loadMyOutstandingCommitments", { commitments, isDone: DEFAULT_PAGE_SIZE !== commitments.length, } );
	},
} );



// WEBPACK FOOTER //
// ./src/store/modules/myCommitments/myCommitmentsApiOrchestrator.js